const readCssVar = (name: string, fallback: string): string => {
  try {
    if (typeof window !== 'undefined') {
      const v = getComputedStyle(document.documentElement).getPropertyValue(name).trim();
      return v || fallback;
    }
  } catch {}
  return fallback;
};

export const CURATED_FONTS = [
  {
    label: 'Inter',
    value: ((): string => {
      const stack = readCssVar('--font-sans-stack', 'Inter, system-ui, -apple-system, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif');
      return stack;
    })()
  },
  {
    label: 'JetBrains Mono',
    value: ((): string => {
      const stack = readCssVar('--font-mono-stack', 'JetBrains Mono, ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace');
      return stack;
    })()
  },
  {
    label: 'Georgia',
    value: 'Georgia, serif'
  },
  // Requested font families
  { label: 'Arial', value: 'Arial, Helvetica, sans-serif' },
  { label: 'Helvetica', value: 'Helvetica, Arial, sans-serif' },
  { label: 'Times New Roman', value: '"Times New Roman", Times, serif' },
  { label: 'Cambria', value: 'Cambria, Georgia, serif' },
  { label: 'Computer Modern', value: '"Computer Modern", "Latin Modern Roman", "CMU Serif", serif' },
  { label: 'DejaVu Sans', value: 'DejaVu Sans, Verdana, Geneva, sans-serif' },
  { label: 'Courier', value: '"Courier New", Courier, monospace' },
  { label: 'Symbol', value: 'Symbol, "Noto Sans Symbols 2", "Noto Sans Symbols", sans-serif' },
  { label: 'Calibri', value: 'Calibri, "Segoe UI", Arial, sans-serif' },
  { label: 'Verdana', value: 'Verdana, Geneva, Tahoma, sans-serif' }
];


